export default __webpack_public_path__ + "static/media/leave_group.ddce612a.png";